import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, RefreshCw } from "lucide-react";
import { SyncReport } from "../data/segmentSync";
interface SyncReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  report: SyncReport | null;
  documentTitle?: string;
}
export function SyncReportModal({
  isOpen,
  onClose,
  report,
  documentTitle
}: SyncReportModalProps) {
  if (!report) return null;
  const rows = [{
    label: "New Sections Added",
    value: report.newSections
  }, {
    label: "Existing Sections Changed",
    value: report.changedSections
  }, {
    label: "Sections Removed",
    value: report.removedSections
  }, {
    label: "Approved Sections Preserved",
    value: report.approvedPreserved
  }, {
    label: "Requires Translator Review",
    value: report.requiresReview
  }, {
    label: "Unchanged Sections",
    value: report.unchanged
  }];
  return <AnimatePresence data-id="element-222">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-slate-900/40 z-40" data-id="element-223" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-224">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md pointer-events-auto overflow-hidden" data-id="element-225">
              <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100" data-id="element-226">
                <div className="flex items-center gap-3" data-id="element-227">
                  <div className="p-2 bg-indigo-50 rounded-lg text-indigo-600" data-id="element-228">
                    <RefreshCw className="w-5 h-5" data-id="element-229" />
                  </div>
                  <div data-id="element-230">
                    <h2 className="text-lg font-semibold text-slate-900" data-id="element-231">
                      Sync Report
                    </h2>
                    {documentTitle && <p className="text-xs text-slate-500 truncate max-w-[240px]" data-id="element-232">
                        {documentTitle}
                      </p>}
                  </div>
                </div>
                <button onClick={onClose} className="p-1.5 text-slate-400 hover:text-slate-700 hover:bg-slate-100 rounded-lg" data-id="element-233">
                  <X className="w-5 h-5" data-id="element-234" />
                </button>
              </div>
              <div className="px-6 py-5 space-y-3" data-id="element-235">
                {rows.map(row => <div key={row.label} className="flex items-center justify-between text-sm" data-id="element-236">
                    <span className="text-slate-600" data-id="element-237">{row.label}</span>
                    <span className="font-semibold text-slate-900 tabular-nums" data-id="element-238">
                      {row.value}
                    </span>
                  </div>)}
              </div>
              <div className="px-6 py-4 bg-slate-50 border-t border-slate-100" data-id="element-239">
                <button onClick={onClose} className="w-full py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700 transition-colors" data-id="element-240">
                  Done
                </button>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}